var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",attrs:{"id":"avaliacoes-home"}},[_c('div',{attrs:{"id":"avaliacoes-intro"}},[_c('p',[_vm._v("Nenhuma avaliação encontrada. Favor verificar o link digitado.")])])])
}]

export { render, staticRenderFns }